import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Homepage.module.css";
import { useAuth } from "../contexts/AuthContext";

const HomePage = () => {
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <div className={styles.container}>
      <h1 className={styles.headerTitle}>Fluency Data Add</h1>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/vocabulary")}>
          <h2 className={styles.title}>Vocabulary</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/passages")}>
          <h2 className={styles.title}>Passages</h2>
        </div>
      </div>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/cities")}>
          <h2 className={styles.title}>Cities</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/course")}>
          <h2 className={styles.title}>Course</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/lessons")}>
          <h2 className={styles.title}>Lessons</h2>
        </div>
      </div>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/metrics")}>
          <h2 className={styles.title}>Metrics</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/trivia")}>
          <h2 className={styles.title}>Trivia</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/course-customization")}>
          <h2 className={styles.title}>Course Customization</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/course-progress")}>
          <h2 className={styles.title}>Course Progress</h2>
        </div>
      </div>
      <div className={styles.columns}>
        <div className={styles.column} onClick={() => handleNavigate("/section-media")}>
          <h2 className={styles.title}>Section Media</h2>
        </div>
        <div className={styles.column} onClick={() => handleNavigate("/language-instructions")}>
          <h2 className={styles.title}>Language Instructions</h2>
        </div>
        {isAdmin && (
          <div
            className={`${styles.column} ${styles.adminColumn}`}
            onClick={() => handleNavigate("/admin/users")}
          >
            <h2 className={styles.title}>User Management</h2>
          </div>
        )}
        {isAdmin && (
          <div
            className={`${styles.column} ${styles.adminColumn}`}
            onClick={() => handleNavigate("/feedback")}
          >
            <h2 className={styles.title}>Feedback</h2>
          </div>
        )}
        {isAdmin && (
          <div
            className={`${styles.column} ${styles.adminColumn}`}
            onClick={() => handleNavigate("/affiliate")}
          >
            <h2 className={styles.title}>Affiliate Program</h2>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePage;
